<template>
  <div class="my-challenge">
    <DataTable :value="myChallenge">
      <Column field="name" header="Name"></Column>
      <Column field="type" header="Challenge Type"></Column>
      <Column field="type" header="Action">
         <template #body="slotProps">
          <IziIcon @click="removeChallenge($event, slotProps.data.id)">delete</IziIcon>
          <ConfirmPopup></ConfirmPopup>
         </template>
      </Column>
    </DataTable>
  </div>
</template>
<script lang="ts">
import { computed } from "vue";
import { ActionTypes } from "../../../store/actions";
import Base from "../../base/Base.vue";
export default class MyChallenge extends Base {
  public myChallenge = computed(() => this.store.getters.getMyChallenge);
  created() {
    console.log(this.myChallenge);
  }

  removeChallenge(event: any, id: any) {
    this.store.dispatch(ActionTypes.REMOVE_CHALLENGE, id);
  }
}
</script>

